<template>
    <div>
        <el-button
            type="text"
            icon="el-icon-plus"
            class="subscribe-button"
            @click="click"
        ></el-button>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        parent: {
            type: Object,
            required: true,
        }
    },

    data (){
        return {

        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
        click (){
            this.parent.onAddConfiguration();
        }
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Channels/configurationButton/add-btn.vue